import { createActionGroup, props } from "@ngrx/store";
import { InterestRate } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

// **************************************************************************
// INTEREST RATES ACTIONS
// CRUD actions only - data loading uses global store
// **************************************************************************
export const InterestRatesActions = createActionGroup({
    source: "Super User / Interest Rates",
    events: {
        "Update Interest Rate": props<{ request: InterestRate }>(),
        "Update Interest Rate Success": props<{ toastKey: string }>(),
        "Update Interest Rate Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
